
var initialColors = [
  {
   id: "default",
   name: "Default",
   fill: "transparent",
   darkBG: "black",
   secondary: "black",
   style: ''
   },
  {
    id: "cyan",
    name: "Cyan",
    fill: "#00B2CE",
    darkBG: "#00B2CE",
    secondary: "#00B2CE"
  },
  {
    id: "skyBlue",
    name: "Sky Blue",
    fill: "#67BCDB",
    darkBG: "#67BCDB",
    secondary: "#67BCDB"
  },
  {
    id: "navy",
    name: "Navy",
    fill: "#384B70",
    darkBG: "#384B70",
    secondary: "#384B70"
  },
  {
    id: "emerald",
    name: "Emerald",
    fill: "#009494",
    darkBG: "#009494",
    secondary: "#009494"
  },
  {
    id: "olive",
    name: "Olive",
    fill: "#A2AB58",
    darkBG: "#A2AB58",
    secondary: "#A2AB58"
  },
  {
    id: "sage",
    name: "Sage",
    fill: "#7E8F7C",
    darkBG: "#7E8F7C",
    secondary: "#7E8F7C"
  },
  {
    id: "eggplant",
    name: "Eggplant",
    fill: "#693E53",
    darkBG: "#693E53",
    secondary: "#693E53"
  },
  {
    id: "burgandy",
    name: "Burgandy",
    fill: "#7D1935",
    darkBG: "#7D1935",
    secondary: "#7D1935"
  },
  {
    id: "cherry",
    name: "Cherry",
    fill: "#CD0920",
    darkBG: "#CD0920",
    secondary: "#CD0920"
  },
  {
    id: "fuscia",
    name: "Fuscia",
    fill: "#DF3D82",
    darkBG: "#DF3D82",
    secondary: "#DF3D82"
  },
  {
    id: "coral",
    name: "Coral",
    fill: "#E95957",
    darkBG: "#E95957",
    secondary: "#E95957"
  },
  {
    id: "tangerine",
    name: "Tangerine",
    fill: "#FF991C",
    darkBG: "#FF991C",
    secondary: "#FF991C"
  },
  {
    id: "mustard",
    name: "Mustard",
    fill: "#F5B72D",
    darkBG: "#F5B72D",
    secondary: "#F5B72D"
  },
  {
    id: "canary",
    name: "Canary",
    fill: "#F2DE10",
    darkBG: "#F2DE10",
    secondary: "#F2DE10"
  },
  {
    id: "earth",
    name: "Earth",
    fill: "#493C3D",
    darkBG: "#493C3D",
    secondary: "#493C3D"
  },
  {
    id: "stone",
    name: "Stone",
    fill: "#7F7468",
    darkBG: "#7F7468",
    secondary: "#7F7468"
  },
  {
    id: "slate",
    name: "Slate",
    fill: "#626264",
    darkBG: "#626264",
    secondary: "#626264"
  }
];

function defaultStyle(color) {
  return `
    #theme-container .primaryBG, .primaryBG { background-color: ${color.fill}; }
    #theme-container .primaryFG, .primaryFG { color: ${color.fill}; }
    #theme-container .primaryBorder, .primaryBorder { border-color: ${color.fill}; }
    #theme-container .primaryFGHover:hover, .primaryFGHover:hover { color: ${color.fill}; }
    #theme-container .primaryBGHover:hover, .primaryBGHover:hover { background-color: ${color.fill}; }
    #theme-container .primaryBGActive .active, .primaryBGActive .active{ background-color: ${color.fill}; }
    #theme-container .secondaryBG, .secondaryBG { background-color: ${color.secondary}; }
    #theme-container .secondaryFG, .secondaryFG { color:  ${color.secondary}; }
    #theme-container .secondaryBorder, .secondaryBorder { border-color:  ${color.secondary}; }
    h1.form-header { background-color: ${color.fill}; border-bottom-color: ${color.darkBG}; }
    input[type="submit"], button[type="submit"] { background-color: ${color.fill}; }       
  `;
}

module.exports = initialColors.map(color => {
  if (typeof color.style === "undefined") {
    color.style = defaultStyle(color);
  }
  return color
});
